import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import '@css/fade-in.css';

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

export default function CaseStudy({ data }) {
    const { caseStudiesBlocks, caseStudiesTitle } = data;
    const [visibleCaseStudies, setVisibleCaseStudies] = useState(4);
    const loadMoreCount = 4;

    const loadMoreCaseStudies = () => {
        setVisibleCaseStudies(visibleCaseStudies + loadMoreCount);
    };
    return (
        <div className='our-work-casestudy-wrap light-grey-bg' id='case-studies'>
            <div className='container'>
                <div className='row ow-case-head'>
                    <div className='col-md-12 text-center'>
                        <h2 className='heading-level-2 blue-color'>{caseStudiesTitle}</h2>
                    </div>
                </div>
                <div className='row hide-mobile'>
                    {caseStudiesBlocks?.slice(0, visibleCaseStudies).map((block, i) => (
                        <div className='col-md-3 fade-in' key={i}>
                            <div className='casestudy-slide-bx'>
                                <a
                                    className='overlay-link'
                                    href={`https://worldsavvy.org/${block.caseStudiesCaseStudyFile?.filename}`}
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {block.caseStudiesCaseStudyFile?.publicUrl}
                                </a>
                                <figure className='case-study-round-image'>
                                    <GatsbyImage
                                        image={getImage(block.caseStudiesCaseStudyImage?.localFile)}
                                        alt='image'
                                    />
                                </figure>
                                <div className='slider-green-overlay'>
                                    <div className='heading-level-5-i'>
                                        {block.caseStudiesCaseStudyTitle}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='row hide-mobile'>
                    <div className='col-md-12 resource-casestudy-btn-sec text-center'>
                        {visibleCaseStudies < caseStudiesBlocks?.length && (
                            <button className='btn blue-btn' onClick={loadMoreCaseStudies}>
                                Explore More case studies
                            </button>
                        )}
                    </div>
                </div>
                <div className='hide-desk resource-m-slider-sec  slick-image-arrow'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <Slider {...settings}>
                                {caseStudiesBlocks?.map((block, i) => (
                                    <div key={i}>
                                        <div className='casestudy-slide-bx'>
                                            <a
                                                className='overlay-link'
                                                href={`https://worldsavvy.org/${block.caseStudiesCaseStudyFile?.filename}`}
                                                target='_blank'
                                                rel='noreferrer'
                                                aria-label={`Read case study: ${block.caseStudiesCaseStudyTitle}`}
                                            >
                                                {block.caseStudiesCaseStudyFile?.publicUrl}
                                            </a>
                                            <figure className='case-study-round-image'>
                                                <GatsbyImage
                                                    image={getImage(block.caseStudiesCaseStudyImage?.localFile)}
                                                    alt='image'
                                                />
                                            </figure>
                                            <div className='slider-green-overlay'>
                                                <div className='heading-level-5-i'>
                                                    {block.caseStudiesCaseStudyTitle}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    )
}
